import React, { useState, useContext, useEffect } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import AuthContext from "../../context/Services/Auth";

import { AiOutlineUser, AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

import defaultLogo from '../../Assets/logo/logo_png.png';
import { get_public_branding } from '../../context/Services/Branding';

const Login = () => {
	const navigate = useNavigate();
	const { loginUser, authTokens } = useContext(AuthContext);

	const [show, setShow] = useState(true);
	const [logo, setLogo] = useState(defaultLogo);

	const [email, setEmail] = useState(null);
	const [pass, setPass] = useState(null);

	const [wrongCreds, setWrongCreds] = useState(false);

	// Fetch dynamic logo
	useEffect(() => {
		const fetchLogo = async () => {
			try {
				const res = await get_public_branding('website_logo');
				if (res?.data) {
					setLogo(res.data);
				}
			} catch (e) {
				console.log('Using default logo');
			}
		};
		fetchLogo();
	}, []);

	const login = async () => {
		let isLogged = await loginUser({ email: email, password: pass });

		if (isLogged) {
			isLogged?.role === "sub_manager" ? navigate('/confirmers') : navigate('/');
			return 0;
		} else {
			setWrongCreds(true);

			setTimeout(() => { setWrongCreds(false) }, 2000)
			return 1
		}
	}

	useEffect(() => {
		if (authTokens) {
			navigate('/');
		}
	}, [authTokens])


	return (
		<div className="app-flex wrap full-v" style={{ height: "100vh", backgroundColor: "white" }}>
			<img src={logo} className="logo" alt="logo" />
			{wrongCreds &&
				<div className="error">
					<h5>Wrong credentials.</h5>
				</div>}
			<div className="form app-flex space">
				<label for="email" className="input flex gap">
					<input id="email" placeholder="email" type="text" className="sub-input" onChange={(e) => setEmail(e.target.value)} />
					<AiOutlineUser className="icon" />
				</label>
				<label for="password" className="input flex gap">
					<input id="password" placeholder="password" type={show ? 'password' : 'text'} className="sub-input" onChange={(e) => setPass(e.target.value)} />
					{show ? <AiFillEye className="icon pointer" onClick={() => setShow(!show)} /> : <AiFillEyeInvisible className="icon pointer" onClick={() => setShow(!show)} />}
				</label>
			</div>

			<button className="btn_login pointer" onClick={() => login()}>
				Login
			</button>
		</div>
	)
}

export default Login